
import { useState, useEffect } from 'react';

export const useReadingPreferences = () => {
  // Reading settings with new defaults
  const [fontSize, setFontSize] = useState(() => {
    return localStorage.getItem('reader-font-size') || '16px';
  });
  
  const [fontFamily, setFontFamily] = useState(() => {
    return localStorage.getItem('reader-font-family') || 'sans-serif';
  });
  
  const [alignment, setAlignment] = useState<'left' | 'justify' | 'center'>(() => {
    return (localStorage.getItem('reader-alignment') as 'left' | 'justify' | 'center') || 'justify';
  });
  
  const [theme, setTheme] = useState<'light' | 'dark' | 'sepia'>(() => {
    return (localStorage.getItem('reader-theme') as 'light' | 'dark' | 'sepia') || 'light';
  });
  
  // Save settings to localStorage when they change
  useEffect(() => {
    localStorage.setItem('reader-font-size', fontSize);
  }, [fontSize]);

  useEffect(() => {
    localStorage.setItem('reader-font-family', fontFamily);
  }, [fontFamily]);

  useEffect(() => {
    localStorage.setItem('reader-alignment', alignment);
  }, [alignment]);
  
  useEffect(() => {
    localStorage.setItem('reader-theme', theme);
  }, [theme]);
  
  // Return the settings and their setters
  return {
    fontSize, setFontSize,
    fontFamily, setFontFamily,
    alignment, setAlignment,
    theme, setTheme
  };
};
